import { memo } from 'react';

/** Memoised treasure chest SVG. Props: size */
export const ChestSvg = memo(function ChestSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      {/* Shadow */}
      <ellipse cx="20" cy="37" rx="14" ry="3" fill="rgba(0,0,0,0.28)"/>
      {/* Chest body */}
      <rect x="4" y="20" width="32" height="17" rx="3" fill="#6b3010" stroke="#3a1500" strokeWidth="1.5"/>
      {/* Chest lid */}
      <path d="M4 22 Q4 12 20 12 Q36 12 36 22" fill="#8b4513" stroke="#3a1500" strokeWidth="1.5"/>
      {/* Lid top band */}
      <path d="M4 20 Q4 14 20 14 Q36 14 36 20" fill="#a0522d" stroke="#3a1500" strokeWidth="1"/>
      {/* Left hinge */}
      <rect x="6" y="18" width="4" height="8" rx="1" fill="#c8a032" stroke="#8b6914" strokeWidth="1"/>
      {/* Right hinge */}
      <rect x="30" y="18" width="4" height="8" rx="1" fill="#c8a032" stroke="#8b6914" strokeWidth="1"/>
      {/* Lock clasp */}
      <rect x="16" y="22" width="8" height="7" rx="2" fill="#c8a032" stroke="#8b6914" strokeWidth="1"/>
      <circle cx="20" cy="26" r="1.8" fill="#8b6914"/>
      {/* Chest band */}
      <line x1="4" y1="25" x2="36" y2="25" stroke="#c8a032" strokeWidth="1" opacity="0.45"/>
    </svg>
  );
});
